import React from 'react'
import ClassicPointsExchangePage from '../components/ClassicPointsExchangePage'

const PointsMoneytopointPage: React.FC = () => {
  return <ClassicPointsExchangePage mode="moneytopoint" />
}

export default PointsMoneytopointPage
